import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { NotifyService } from "src/app/services/notify.service";
import { EncryptionService } from "../../services/encryption.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  validity: "draft" | "valid" | "invalid" = "draft";
}
